export const DATE_LONG_FORMAT = 'dddd D MMMM YYYY'
export const DATE_SHORT_FORMAT = 'D MMM YYYY'
export const DATE_STORE_KEY_FORMAT = 'YYYY-MM-DD'
export const DATE_SUBMIT_FORMAT = 'YYYY-MM-DD HH:mm:ss'
